import {AccountExternal} from "@bounce/shared/consumer/declarations";
import {get, isEmpty} from "lodash";
import {
  ACCOUNT_CLOSED,
  ACCOUNT_MANAGED_BY_JANUARY,
  ACTIVE_DISPUTE,
  BANKRUPTCY,
  CREDITOR_RECALLED,
  FRAUD,
  getExternalCollectorDisclaimer,
  LEGAL_COLLECTION,
  STATUTE_OF_LIMITATIONS,
} from "~/constants/disclaimers";

const getBlockedAccountInformation = (account: AccountExternal, userState?: string) => {
  const inActiveDispute = account?.active_dispute;
  const inCreditorRecalled = account?.status === "creditor_recalled";
  const inFraud = account?.status === "fraud_reported";
  const inLegalCollection = account?.status === "legal_collection";
  const inBankruptcy = !!account?.bankruptcy_id;
  const accountManagedByExternalCollector = !isEmpty(account?.external_collector);
  const isStatuteBarred = account?.statute_barred;
  const isAccountClosed = account?.closed;
  const hasActivePlan = !!account?.active_payment_plan;
  if (inLegalCollection) {
    return {text: LEGAL_COLLECTION, reason: "legal_collection"};
  } else if (inCreditorRecalled) {
    return {text: CREDITOR_RECALLED, reason: "creditor_recalled"};
  } else if (isAccountClosed) {
    return {text: ACCOUNT_CLOSED, reason: "account_closed"};
  } else if (inBankruptcy) {
    return {text: BANKRUPTCY, reason: "bankruptcy"};
  } else if (isStatuteBarred && !hasActivePlan && userState) {
    return {
      text: get(STATUTE_OF_LIMITATIONS, userState?.toLowerCase()) || get(STATUTE_OF_LIMITATIONS, "default"),
      reason: "statute_of_limitations",
    };
  } else if (inFraud) {
    return {text: FRAUD, reason: "fraud"};
  } else if (inActiveDispute) {
    return {text: ACTIVE_DISPUTE, reason: "active_dispute"};
  } else if (accountManagedByExternalCollector) {
    if (account?.external_collector?.toLowerCase().includes("january")) {
      return {text: ACCOUNT_MANAGED_BY_JANUARY, reason: "january_account"};
    } else {
      return {
        text: account?.external_collector && getExternalCollectorDisclaimer(account?.external_collector),
        reason: "external_collector_account",
      };
    }
  }
  return {text: "", reason: ""};
};

export {getBlockedAccountInformation};
